export class BookmarkNode {
    public id: string = '';
    public text: string = '';
    public page: number = 0;
    public items: BookmarkNode[] | null = null;
}
